// src/pages/Main/stage/index.js

import React, { Component } from 'react';
import "./index.css";

/**
 * A dark band. Where WebGL exists it starts the turning workflow mesh behind its content; everywhere else the
 * band's own gradient is the whole picture.
 */
export default class Stage extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.stop = null;
    this.unmounted = false;
  }

  componentDidMount() {
    if (typeof window === "undefined" || !("WebGLRenderingContext" in window)) {
      return;
    }
    import('pages/Main/stage/flowLoop').then(({ register }) => {
      if (!this.unmounted && this.ref.current) {
        this.stop = register(this.ref.current, this.props.kind);
      }
    }).catch(() => {});
  }

  componentWillUnmount() {
    this.unmounted = true;
    if (this.stop) {
      this.stop();
    }
  }

  render() {
    const { kind, className, id, tabIndex, labelledBy, children } = this.props;
    return (
      <section ref={this.ref} id={id} tabIndex={tabIndex} aria-labelledby={labelledBy}
               className={["fp-stage", `fp-stage-${kind}`, className].filter(Boolean).join(" ")}>
        {children}
      </section>
    );
  }
}
